import { Paper, Typography } from "@mui/material";
import ProductTypeFilterCard from "./ProductTypeFilter/ProductTypeFilterCard";
import ProductTypeTable from "./ProductTypeTable/ProductTypeTable";
import { useEffect, useState } from "react";
import { selectUserData, setIsLoading } from "../../../../features/userSlice";
import { MetaEntitiesEndPointLogic } from "../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Page404 from "../../../Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

interface ProductTypeProps {
  oauthTokenHeader: any;
}

const tableHeadings = {
  type_name: "Product Type",
  created: "Created on",
  created_by: "Created By",
  modified: "Last edited",
  modified_by: "Edited By",
};

const ProductType = ({ oauthTokenHeader }: ProductTypeProps) => {
  const [selectedProductType, setSelectedProductType] = useState(null);
  const [metaProductType, setMetaProductType] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasViewProductTypePermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "view_products_types"
  );

  useEffect(() => {
    const fetchMetaEntitiesDataType = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        await MetaEntitiesEndPointLogic.getMetaProductType(
          oauthTokenHeader,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching Meta Entities:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchMetaEntitiesDataType();
    }
  }, [oauthTokenHeader, dispatch]);

  if (!hasViewProductTypePermission) {
    return <Page404 />;
  }

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper
            sx={{
              boxShadow: "none",
              padding: "8px 16px 0px",
              borderEndEndRadius: "0px",
              borderBottomLeftRadius: "0px",
            }}
          >
            <Typography fontSize={24}>Product Types List</Typography>
            <ProductTypeFilterCard />
          </Paper>
          <Paper
            sx={{
              boxShadow: "none",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <ProductTypeTable
              tableHeadings={tableHeadings}
              setMetaProductType={setMetaProductType}
              oauthTokenHeader={oauthTokenHeader}
              loading={loading}
              metaProductType={metaProductType}
              selectedProductType={selectedProductType}
              setSelectedProductType={setSelectedProductType}
            />
          </Paper>
        </>
      )}
    </>
  );
};

export default ProductType;
